import React, { Component } from "react";
import classes from "./Header.module.css";

import LogoAndIco from "./LogoAndIco";
import Form from "./Form";
import Aux from "../../hoc/Aux";
import UserProfile from "./UserProfile";
import Modal from "../SideBar/Modal";

import { connect } from "react-redux";
import { search, getRegion } from "../../Actions/index";

class Header extends Component {
  state = {
    searchText: sessionStorage.getItem("query") || "",
    fullSizeSearchBox: false,
    modal: false
  };
  toggleSideBar = () => {
    const width = window.innerWidth;
    if (width >= 1150) this.props.toggleMiniSidebar();
    this.setState(preState => ({ modal: !preState.modal }));
  };
  showFullSizeSearchBox = () => {
    this.setState(preState => ({
      fullSizeSearchBox: !preState.fullSizeSearchBox
    }));
  };
  onChangeHandler = e => {
    this.setState({ searchText: e.target.value });
  };
  onSubmitHandler = e => {
    e.preventDefault();
    window.scroll(0, 0);
    this.props.search(this.state.searchText);

    sessionStorage.setItem("query", this.state.searchText);
    if (window.location.pathname !== "/results") {
      this.props.history.push({
        pathname: "/results"
      });
    }
  };
  componentDidMount() {
    this.props.getRegion();
  }
  render() {
    let markup = (
      <Aux>
        <LogoAndIco
          toggleSideBar={this.toggleSideBar}
          country={this.props.code}
        />
        <Form
          value={this.state.searchText}
          onChange={this.onChangeHandler}
          onSubmit={this.onSubmitHandler}
          onlyDesktop={true}
        />
        <div className={classes.Icons}>
          <i
            onClick={this.showFullSizeSearchBox}
            className={[classes.OnlyMobile, "fas fa-search"].join(" ")}
          />
          <i
            className={["fas fa-video ", classes.OnlyMediumMobile].join(" ")}
          />
          <div>
            <i className="fas fa-ellipsis-v" />
            <i className="fas fa-ellipsis-v" />
            <i className="fas fa-ellipsis-v" />
          </div>
          <i
            className={[classes.OnlyMediumMobile, "fas fa-comment-dots"].join(
              " "
            )}
          />
          <i
            className={["fas fa-ellipsis-v", classes.OnlyMediumMobile].join(
              " "
            )}
          />
          <UserProfile />
        </div>
      </Aux>
    );
    if (this.state.fullSizeSearchBox) {
      markup = (
        <Aux>
          <div onClick={this.showFullSizeSearchBox}>
            <i className={["fas fa-arrow-left", classes.BackArrow].join(" ")} />
          </div>
          <Form
            value={this.state.searchText}
            onChange={this.onChangeHandler}
            onSubmit={this.onSubmitHandler}
            onlyDesktop={false}
            style={{ width: "90%" }}
          />
        </Aux>
      );
    }
    return (
      <header className={classes.Header}>
        {markup}
        <Modal
          toggleSideBar={this.toggleSideBar}
          extraClass={this.state.modal ? true : false}
          country={this.props.code}
        />
      </header>
    );
  }
}
const mapStateToProps = state => {
  return {
    code: state.regionCode
  };
};
export default connect(
  mapStateToProps,
  { search, getRegion }
)(Header);
